// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgTrendUpIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M17.92 6.62c-.1-.25-.3-.44-.54-.54A1 1 0 0 0 17 6H8c-.55 0-1 .45-1 1 0 .551.45 1.002 1 1.002h6.59l-8.3 8.297A.997.997 0 0 0 7 18c.26 0 .51-.1.71-.29L16 9.413v6.595c0 .55.45 1.001 1 1.001s1-.45 1-1V7c0-.13-.03-.26-.08-.38" />
  </g>
);
export default SvgTrendUpIcon;
SvgTrendUpIcon.displayName = 'SvgTrendUpIcon';
